<mat-toolbar color="warn" *ngIf="showBar"
             class="invalid-payment-toolbar">
    <div style="font-size: 14px;">
        <span *ngIf="invalidPayment">
            The payment method on the subscription is invalid.  Please update your subscription before we
            retry your payment
        </span>
        <span *ngIf="cardExpiring">
            The payment method on this subscription is nearing or passed expiry
        </span>
    </div>
    <span class="example-fill-remaining-space"></span>
    <span>
        <button mat-button [routerLink]="paymentUrl">
            <mat-icon>credit_card</mat-icon>
            Update your payment
        </button>
    </span>
</mat-toolbar>